const CONSTRUCTION_PROGRESS_COMPONENT = document.querySelector('.construction-progress-component');

function createPaginationIcon( buttonClass, iconClass, tooltipText ) {
  let btn = document.createElement('button');
  btn.classList = buttonClass;
  let icon = document.createElement('span');
  icon.classList = iconClass;
  btn.appendChild(icon);
  let tooltip = document.createElement('span');
  tooltip.classList.add('visually-hidden');
  tooltip.innerText = tooltipText;
  btn.appendChild(tooltip);
  return btn;
}

if (CONSTRUCTION_PROGRESS_COMPONENT) {
  const CONSTRUCTION_CONTENT_WRAPPER = document.createElement('div');
  CONSTRUCTION_CONTENT_WRAPPER.classList = 'construction-content-wrapper';
  const paginationComponent = document.createElement('div');
  paginationComponent.setAttribute('id', 'pagination');
    CONSTRUCTION_PROGRESS_COMPONENT.appendChild(CONSTRUCTION_CONTENT_WRAPPER);
    CONSTRUCTION_PROGRESS_COMPONENT.appendChild(paginationComponent);

    let currentPage = 1;
    const SCROLL_TOP = () => {
        scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    };
    let getConstructionProgress = async function (filterTag) {
        loadMsg.innerText = document.querySelector('.rest-message--success').value;
        loadMsg.classList = 'loader-title';
        CONSTRUCTION_PROGRESS_COMPONENT.appendChild(loadWrap);
        CONSTRUCTION_CONTENT_WRAPPER.style.display = 'none';
        paginationComponent.style.display = 'none';
        let num_per_page = document.querySelector('.page-number').value;
        let filter_type = document.querySelector('.filterType').value;
        let cp_id = document.querySelector('.cp-id').value;
        let response = await fetch(
            `${APIPrefix.get()}/search_api/mhp/constructionprogress/list?filterType=${filter_type}&filterValue=${filterTag}&noOfItemsPerPage=${num_per_page}&cpId=${cp_id}`
        );
        if (response.status == 200) {
            let data = await response.json();
            if (data.status == "failure") {
                loadMsg.innerText = document.querySelector('.rest-message--fail').value;
                loadMsg.classList = 'error-title';
                CONSTRUCTION_PROGRESS_COMPONENT.removeChild(loadWrap);
                CONSTRUCTION_CONTENT_WRAPPER.style.display = 'none';
                CONSTRUCTION_PROGRESS_COMPONENT.appendChild(loadMsg);
                return false;
            } else if (data.status === "401") {
                APIUtils.redirectUserToSigninPage();
            } else {
                CONSTRUCTION_CONTENT_WRAPPER.style.display = 'flex';
                paginationComponent.style.display = 'flex';
                CONSTRUCTION_PROGRESS_COMPONENT.removeChild(loadWrap);
                return data;
            }
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    };

    let diplayFilteredList = function (items, wrapper, rows_per_page, page) {
        wrapper.innerHTML = '';
        page--;
        let start = rows_per_page * page;
        let end = start + rows_per_page;
        let paginatedItems = items.slice(start, end);
        for (let item of paginatedItems)  {
            let item_element = `
                <div class="card-item">
                  ${item.image.path ? 
                    `<a href = "${item.viewButton.url}" title="${item.viewButton.tooltip}"><img src="${item.image.path}" alt="${item.image.alt}"></a>` : 
                    ``
                  }
                  <h3 class="progress-title">${item.title}</h3>
                  <p class="progress-desc">${item.description}</p>
                  <a class="progress-cta button" href="${item.viewButton.url}" title="${item.viewButton.tooltip}">${item.viewButton.name}</a>
                </div>
              `;
      wrapper.innerHTML += item_element;
    }
  };

  const SELECT_FILTER = document.querySelector('#constructionProgress');
  window.addEventListener('load', () => {
    if (SELECT_FILTER) {
      // Dispatch a 'change' event to trigger any listeners
      SELECT_FILTER.dispatchEvent(new Event('change', { bubbles: false, cancelable: true }));
    }
    windowUtils.addOrientationListener(() => {
      if (SELECT_FILTER) {
        SELECT_FILTER.blur();
      }
    });
  });

  SELECT_FILTER.addEventListener('change', () => {
    let value = SELECT_FILTER.options[SELECT_FILTER.selectedIndex].value;
    getConstructionProgress(value)
      .then((data) => {
        if(data){
        const FILTERED_PROGRESS = data.data.items;
        let currentPage = 1;
        let rows = data.data.configuration.itemsPerPage;
        const CONSTRUCTION_CONFIGURATION = data.data.configuration;

        let setupMixedPagination = function (items, wrapper, rows_per_page) {
          wrapper.innerHTML = '';
          let pageCount = Math.ceil(items.length / rows_per_page);
          for (let i = 1; i < pageCount + 1; i++) {
            let fltbtn = FilteredPaginationButton(i, items, pageCount, CONSTRUCTION_CONFIGURATION.tooltips);
            wrapper.appendChild(fltbtn);
          }

          let nextBtn = createPaginationIcon( 'page-next', 'icon-single-chevron', CONSTRUCTION_CONFIGURATION.tooltips.nextPage );
          let prevBtn = createPaginationIcon( 'page-prev', 'icon-single-chevron-left', CONSTRUCTION_CONFIGURATION.tooltips.prevPage );
          let firstBtn = createPaginationIcon( 'page-first', 'icon-double-chevron-left', CONSTRUCTION_CONFIGURATION.tooltips.firstPage );
          let lastBtn = createPaginationIcon( 'page-last', 'icon-double-chevron', CONSTRUCTION_CONFIGURATION.tooltips.lastPage );

          let theFirstChild = paginationComponent.firstChild;
          let lastChild = paginationComponent.lastElementChild;
          paginationComponent.insertBefore(prevBtn, theFirstChild);
          paginationComponent.insertBefore(firstBtn, prevBtn);

          function insertAfter(referenceNode, newNode) {
            referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
          }
          insertAfter(lastChild, nextBtn);
          insertAfter(nextBtn, lastBtn);

          if (currentPage == 1) {
            prevBtn.classList.add('disabled');
            prevBtn.setAttribute('tabindex', -1);
          } else {
            prevBtn.classList.remove('disabled');
          }
          if (currentPage == pageCount) {
            nextBtn.classList.add('disabled');
            nextBtn.setAttribute('tabindex', -1);
          } else {
            nextBtn.classList.remove('disabled');
          }
          if (currentPage == 1) {
            firstBtn.classList.add('disabled');
            firstBtn.setAttribute('tabindex', -1);
          } else {
            firstBtn.classList.remove('disabled');
          }
          if (currentPage == pageCount) {
            lastBtn.classList.add('disabled');
            lastBtn.setAttribute('tabindex', -1);
          } else {
            lastBtn.classList.remove('disabled');
          }
          prevBtn.addEventListener('click', () => {
            SCROLL_TOP();

            currentPage = currentPage - 1;
            diplayFilteredList(items, CONSTRUCTION_CONTENT_WRAPPER, rows, currentPage);
            setupMixedPagination(FILTERED_PROGRESS, paginationComponent, rows);
          });

          nextBtn.addEventListener('click', () => {
            SCROLL_TOP();

            currentPage = currentPage + 1;
            diplayFilteredList(items, CONSTRUCTION_CONTENT_WRAPPER, rows, currentPage);
            setupMixedPagination(FILTERED_PROGRESS, paginationComponent, rows);
          });
          firstBtn.addEventListener('click', () => {
            SCROLL_TOP();

            currentPage = 1;
            diplayFilteredList(items, CONSTRUCTION_CONTENT_WRAPPER, rows, currentPage);
            setupMixedPagination(FILTERED_PROGRESS, paginationComponent, rows);
          });
          lastBtn.addEventListener('click', () => {
            SCROLL_TOP();

            currentPage = pageCount;
            diplayFilteredList(items, CONSTRUCTION_CONTENT_WRAPPER, rows, currentPage);
            setupMixedPagination(FILTERED_PROGRESS, paginationComponent, rows);
          });
        };

        let FilteredPaginationButton = function (page, items, pageCount, tooltips) {
          let filtButton = document.createElement('button');
          filtButton.setAttribute('type', 'button');
          filtButton.innerHTML = `<span class="visually-hidden">${tooltips.page}</span> ${page}`;
          filtButton.id = page;
          if (currentPage == page) filtButton.classList.add('active');
          filtButton.addEventListener('click', () => {
            currentPage = page;
            let currentFilteredBtn = document.querySelector('#pagination button.active');
            diplayFilteredList(items, CONSTRUCTION_CONTENT_WRAPPER, rows, currentPage);
            let last = document.querySelector('.page-next');
            let pageLast = document.querySelector('.page-last');
            let first = document.querySelector('.page-first');
            let prev = document.querySelector('.page-prev');

            if (currentPage == pageCount) {
              last.classList.add('disabled');
              pageLast.classList.add('disabled');
              last.setAttribute('tabindex', -1);
              pageLast.setAttribute('tabindex', -1);
            } else {
              last.classList.remove('disabled');
              pageLast.classList.remove('disabled');
              last.setAttribute('tabindex', 0);
              pageLast.setAttribute('tabindex', 0);
            }
            if (currentPage == 1) {
              prev.classList.add('disabled');
              first.classList.add('disabled');
              prev.setAttribute('tabindex', -1);
              first.setAttribute('tabindex', -1);
            } else {
              prev.classList.remove('disabled');
              first.classList.remove('disabled');
              prev.setAttribute('tabindex', 0);
              first.setAttribute('tabindex', 0);
            }
            currentFilteredBtn.classList.remove('active');
            filtButton.classList.add('active');
          });
          return filtButton;
        };
        diplayFilteredList(FILTERED_PROGRESS, CONSTRUCTION_CONTENT_WRAPPER, rows, 1);
        if (FILTERED_PROGRESS.length > rows) {
          setupMixedPagination(FILTERED_PROGRESS, paginationComponent, rows);
          paginationComponent.style.visibility = 'visible';
        } else {
          paginationComponent.style.visibility = 'hidden';
        }
        if (FILTERED_PROGRESS === undefined || FILTERED_PROGRESS.length == 0) {
          CONSTRUCTION_CONTENT_WRAPPER.innerText = CONSTRUCTION_CONFIGURATION.headerTemplateMessage;
          CONSTRUCTION_CONTENT_WRAPPER.classList.add('no-items');
        }
      }
      }).catch((e) =>{
          loadMsg.innerText = document.querySelector('.rest-message--fail').value;
          loadMsg.classList = 'error-title';
          CONSTRUCTION_PROGRESS_COMPONENT.removeChild(loadWrap);
          CONSTRUCTION_CONTENT_WRAPPER.style.display = 'none';
          CONSTRUCTION_PROGRESS_COMPONENT.appendChild(loadMsg);
      });
  });
}